// extracted by css-extract-rspack-plugin
export default {"container":"action-alert-module__container___hnXbZ","localizedText":"action-alert-module__localizedText___Qf_Ca","successCheckmark":"action-alert-module__successCheckmark___I2yQf"};